import React from "react";
import { withStyles } from "material-ui/styles";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { compose } from 'recompose';
import classnames from "classnames";
import styles from "./styles";
import Toolbar from "./toolbar";
import Title from "../ui/title";
import Content from "../ui/content";
import Modal from "material-ui/Modal";

import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Icon from "material-ui/Icon";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";

import { dateTimeFormatter, dateFormatter } from "../../common/utils";
import { ModalHeader, ModalContents, ModalFooter } from "../common/modal";

class IdealAdminDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isIdealAdmin: props.isIdealAdmin || false,
      open: false,
      deviceid: "",
      device: {},
      errors: {}
    };
  }

  showModal = () => {
    this.setState({
      open: true
    });
  };

  closeModal = () => {
    this.setState({
      open: false,
      errors: {}
    });
  };

  handleDevice = e => {
    this.setState({
      deviceid: e.target.value
    });
  };

  handleClick = e => {
    e.preventDefault();
    if (!this.state.deviceid) {
      const textField = document.getElementsByName("deviceid")[0];
      textField && textField.focus();
      this.setState({
        errors: {
          serialnumber: true
        }
      });
      return;
    }
    this.props.searchDeviceDetails(this.state.deviceid.trim());
    this.setState({
      deviceid: "",
      errors: {}
    });
  };

  componentWillReceiveProps(nextPprops) {
    const { isIdealAdmin, device } = nextPprops;
    this.setState({
      isIdealAdmin,
      device
    });
    if (device && typeof device === "object" && Object.keys(device).length) {
      this.setState({
        open: false
      });
    }
  }

  componentWillUnmount() {
    this.props.resetDeviceDetails();
  }
 
  render() {
    const { translate, classes, impersonating, softwareUpdate } = this.props;

    const { isIdealAdmin, device = {}, deviceid, errors, open } = this.state;

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    let searchModal = null;
    if (open) {
      searchModal = (
        <Modal open={open} onClose={this.closeModal}>
          <div className={classes.root}>
            <Paper className={classes.modal}>
              <ModalHeader>
                <Typography type="headline" color="inherit">
                  {translate("job_device")}
                </Typography>
                <Button className={classes.close} onClick={this.closeModal}>
                  <Icon>clear</Icon>
                </Button>
              </ModalHeader>
              <ModalContents>
                <TextField
                  className={classes.textField}
                  required
                  name="deviceid"
                  label={translate("device_details_device_id")}
                  margin="normal"
                  fullWidth
                  value={deviceid}
                  onChange={this.handleDevice}
                  helperText={
                    errors.serialnumber
                      ? translate("formfield_error_general_required")
                      : ""
                  }
                />
              </ModalContents>

              <ModalFooter>
                <Button
                  raised
                  className={classes.button}
                  onClick={this.handleClick}
                >
                  {translate("general_submit")}
                </Button>
              </ModalFooter>
            </Paper>
          </div>
        </Modal>
      );
    }

    if (device) {
      return (
        <div>
          <Title
            title={translate("job_device")}
            toolbar={
              <Toolbar
                translate={translate}
                device={device}
                isIdealAdmin={isIdealAdmin}
                showModal={this.showModal}
              />
            }
          />
          {device.isstolen && (
            <Paper className={classes.error} elevation={0}>
              <Typography type="h2" component="h2" color="secondary">
                {translate("device_registered_stolen")}
              </Typography>
            </Paper>
          )}
          <Content translate={translate}>
            <Grid container spacing={24}>
              {device &&
              typeof device === "object" &&
              Object.keys(device).length ? (
                <React.Fragment>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)} style={{marginTop: margintop}}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_details_device_id")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.deviceserialno}
                          </Typography>
                          <Typography type="subheading" color="error">
                            {device.islocked
                              ? translate("device_locked_status")
                              : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>smartphone</Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)} style={{marginTop: margintop}}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("organisation_name")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.organisationname || ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>
                              account_circle
                            </Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)} style={{marginTop: margintop}}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("general_created_by")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.createdbyname || ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>
                              account_circle
                            </Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("createdat")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.createdat
                              ? dateTimeFormatter(device.createdat)
                              : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>
                              access_time
                            </Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_details_last_online")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.lastonline
                              ? dateTimeFormatter(device.lastonline)
                              : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>
                              access_time
                            </Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_details_location")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.latitude && device.longitude
                              ? `${device.latitude} ${device.longitude}`
                              : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>
                              location_on
                            </Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_details_engineer")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.engineer ? device.engineer : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>
                              account_circle
                            </Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_details_software_version")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.softwareversion
                              ? device.softwareversion
                              : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>sync</Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_details_calibration_due_date")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.calibrationdue
                              ? dateTimeFormatter(device.calibrationdue)
                              : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <React.Fragment>
                            <Icon className={classes.tileIcon}>build</Icon>
                          </React.Fragment>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper
                      className={classnames(classes.paper, classes.infotile)}
                    >
                      <Grid container spacing={0}>
                        <Grid item xs={10}>
                          <Typography type="button" className={classes.text}>
                            {translate("device_registered")}
                          </Typography>
                          <Typography
                            type="heading"
                            className={classnames(
                              classes.text,
                              classes.heading
                            )}
                          >
                            {device.registered
                              ? translate("back_btn_yes")
                              : translate("back_btn_no")}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid
                    container
                    spacing={10}
                    direction="row"
                    sx={{
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Typography component={Link} to={`/organisation/${device.organisationid}`}>
                        <Button
                          raised
                          className={classes.button}
                          type="submit"
                        >
                          {translate("result_organisation")}
                        </Button>
                    </Typography>
                  </Grid>
                </React.Fragment>
              ) : null}
            </Grid>
          </Content>
          {searchModal}
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(IdealAdminDevice);
